import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(email, password);
    } catch (err) {
      setError('Correo o contraseña incorrectos. Verifica tus datos.');
    }
    setLoading(false);
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-stripes">
          <div style={{ background: '#CE1126', flex: 1 }} />
          <div style={{ background: '#fff', flex: 1 }} />
          <div style={{ background: '#009A44', flex: 1 }} />
        </div>
        <div className="login-body">
          <div className="login-title">GestorPrivadas</div>
          <div className="login-sub">Distrito Educativo 1102 · Puerto Plata</div>
          {error && <div className="login-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Correo electrónico</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@correo.com" required />
            </div>
            <div className="form-group">
              <label>Contraseña</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
            </button>
          </form>
          <div className="login-footer">MINERD · Dirección de Acreditación de Centros Educativos</div>
        </div>
      </div>
    </div>
  );
}